const BENV = process.env.BENV || 'prod'

export const getUtmParams = () => {
  return ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
}

export const getClickIdParams = () => {
  return ['gclid', 'fbclid', 'msclkid']
}

export const getAllTrackingParams = () => {
  const utmParams = getUtmParams()
  const clickIdParams = getClickIdParams()
  return utmParams.concat(clickIdParams)
}

export const handleUTMParams = location => {
  if (typeof window === 'undefined') return

  // Enable in case of activation the logic based on Cookiebot consent - Statistics
  if (
    BENV &&
    BENV.startsWith('prod') &&
    (!window.Cookiebot ||
      !window.Cookiebot.consent ||
      !window.Cookiebot.consent.statistics)
  ) {
    console.log('UTM tracking skipped: Statistics consent not given.')
    return
  }

  const urlParams = new URLSearchParams(location.search)
  const utmParams = getUtmParams()

  utmParams.forEach(param => {
    const value = urlParams.get(param)
    if (value !== null) {
      sessionStorage.setItem(param, value)
    }
  })
}

export const handleClickIDParams = location => {
  if (typeof window === 'undefined') return

  // Enable in case of activation the logic based on Cookiebot consent - Statistics
  if (
    BENV &&
    BENV.startsWith('prod') &&
    (!window.Cookiebot ||
      !window.Cookiebot.consent ||
      !window.Cookiebot.consent.statistics)
  ) {
    console.log('Click ID tracking skipped: Statistics consent not given.')
    return
  }

  const urlParams = new URLSearchParams(location.search)
  const clickIds = getClickIdParams()

  clickIds.forEach(param => {
    const value = urlParams.get(param)
    if (value !== null) {
      sessionStorage.setItem(param, value)
    }
  })
}
